import { render, staticRenderFns } from "./InsumosCompuestosCrud.vue?vue&type=template&id=8b395a76"
import script from "./InsumosCompuestosCrud.vue?vue&type=script&lang=js"
export * from "./InsumosCompuestosCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports